<template>
    <div
        id="coin-container"
        class="coin-container loader"
    >
        <div id="coin">
            <div class="coin-item">
                <Coin />
            </div>
        </div>
        <div>
            <div class="coin-fly">
                <Coin />
            </div>
            <div class="coin-fly">
                <Coin />
            </div>
            <div class="coin-fly">
                <Coin />
            </div>
            <!-- <div class="coin-fly">
                <Coin />
            </div> -->
        </div>

        <div class="coin-txt">
            <p class="desc">{{ $t('coin_description') }}</p>
            <p class="title">{{ totalCoinCounting }}</p>
        </div>
        <FallingReward id="falling-reward-container" />
    </div>
</template>

<script>
import gsap from 'gsap'
import Coin from '@/components/Coin'
import FallingReward from '@/components/FallingReward'

export default {
    props: {
        totalCoin: {
            type: Number,
            default: 0
        }
    },

    components: {
        Coin,
        FallingReward
    },

    data() {
        return {
            totalCoinCounting: 0
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.init()
        })
    },

    methods: {
        init() {
            let coinFlyTop = document.getElementById('coin').offsetTop
            let coinFlyRight = document.getElementById('coin').offsetLeft

            if (window.innerWidth < 991) {
                coinFlyRight = document.getElementById('coin').offsetLeft - 25
            }

            // SET COIN ANIMATION
            gsap.set('#coin', { scale: 0.5, opacity: 0, yPercent: 50, force3D: false })
            gsap.set('.coin-fly', {
                opacity: 0,
                top: coinFlyTop,
                right: coinFlyRight
            })

            let tlCoin = gsap.timeline({repeat: 0, repeatDelay: 0, onComplete: () => {
                this.$emit('ended')
            }})
            tlCoin
                .to('#coin', { duration: .3, scale: 1, opacity: 1, yPercent: 0, ease: 'power4.out' })
                .to('#coin', { duration: .5, opacity: 0, ease: 'power4.out', delay: 2 })
                .to('.coin-fly', { duration: .5, opacity: 1, scale: 0.5, ease: 'power4.out' })
                .to('.coin-fly', {
                    duration: .5,
                    scale: 0.3,
                    top: -90,
                    right: -40,
                    stagger: 0.3,
                    ease: 'power4.out'
                })

            tlCoin
                .to('.coin-container .coin-txt', { duration: .5, opacity: 0, delay: -1 })
                .to('.coin-container', { duration: .5, opacity: 0 })

            // SET COUNTING NUMBER
            let timer = setInterval(() => {
                this.totalCoinCounting++

                if (this.totalCoinCounting === this.totalCoin) {
                    clearInterval(timer)
                }
            }, Math.abs(Math.floor(1000 / this.totalCoin)))
        },

        getRndInteger(min, max) {
            return Math.floor(Math.random() * (max - min)) + min
        }
    }
}
</script>

<style lang="scss" scoped>
.coin-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    #coin {
        margin-top: -180px;
        position: relative;

        .coin-item {
            font-size: 1em;
            position: absolute;
            top: 0;

            @media (max-width: 992px) {
                font-size: .7em;
            }

            &:first-child {
                position: relative;
            }
        }
    }

    .coin-fly {
        position: absolute;
        // top: 20%;
    }

    .coin-txt {
        color: white;
        text-align: center;
        font-size: 5em;

        .desc {
            font-size: .45em;
        }

        .title {
            line-height: 1;
            font-weight: bold;
        }
    }
}
</style>
